'use client';

export function TrustBadge() {
  return (
    <div className="my-8 bg-gradient-to-r from-blue-600 to-blue-700 rounded-lg p-6 shadow-xl border border-blue-400/30">
      <div className="flex flex-col md:flex-row items-center justify-center gap-6">
        <div className="text-center md:text-left flex-1">
          <p className="text-white/90 text-sm uppercase tracking-wider font-semibold mb-1">★ Award-Winning Excellence ★</p>
          <p className="text-white font-bold text-lg">AnswerOne: 50+ Years of Proven Reliability</p>
        </div>
        <div className="flex gap-4">
          <div className="text-center">
            <p className="text-white/80 text-xs uppercase tracking-wider mb-1">ATSI Award</p>
            <p className="text-white font-black text-2xl">19 YRS</p>
            <p className="text-white/70 text-xs">Excellence</p>
          </div>
          <div className="h-12 w-px bg-white/30 hidden sm:block"></div>
          <div className="text-center">
            <p className="text-white/80 text-xs uppercase tracking-wider mb-1">CAM-X Award</p>
            <p className="text-white font-black text-2xl">15 YRS</p>
            <p className="text-white/70 text-xs">Top Tier</p>
          </div>
        </div>
      </div>
    </div>
  );
}
